module.exports = __webpack_public_path__ + "static/media/Valentinos_Pariza.3eeb5010.png";